<template>
  <div class="container">

    <br>
    <div class="btn-box">
      <div class="btn active" @click="goto('/reg')">注册 / 登录 </div>
    </div>
    <br>
    <br>

    <div class="round-container">
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" >
            <div class="weui-cell__bd">
               <router-link to="/terms-and-conditions?back=1"><p>服务条款</p></router-link>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" >
            <div class="weui-cell__bd">
               <router-link to="/refund-policy?back=1"><p>退款条款</p></router-link>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="https://www.daojia.com.au/about/contact.html" target="_blank">
            <div class="weui-cell__bd">
               <p>联系我们</p>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" >
            <div class="weui-cell__bd">
               <router-link to="/info"><p>关于我们</p></router-link>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
      </div>
    </div>



  </div>
</template>

<script>
export default {
  name: 'profile',
  data () {
    return {
      userInfo:{
        phone:'',
        email:'',
        name:'',        
      }
    }
  },
  methods: {
    logout(){
      let result = window.confirm("确定要登出账号吗？");
      if(result){
        this.clearLoginLS();
        this.$router.push('/');
      }
    },  
  },
  components: {
  },
  mounted: function () {
    document.querySelector("html").classList.add("profile-bg");
  },
  destroyed() {
    document.querySelector("html").classList.remove("profile-bg");
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.avatar{
  text-align:center;
  margin-top:30px;
  font-size:0;
  img{
    background:#fff;
    border-radius:50%;
    padding:10px;
    width:44px;
  }
}
.btn{
  margin-top:20px;
}
.title{
  font-size:1.6em;
  color:#fff;
  padding-bottom:0;
}
.vip{
  text-align:center;
  margin-bottom:20px;
  img{
    width:60px;
  }
}
.round-container{
  padding: 0 16px 20px 16px;
  .weui-cells{
    margin-top:4px;
    border-radius:8px;
    -webkit-box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.7);
    box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.7);
  }
  .weui-cells:after, .weui-cells:before{
    border:0;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/profile-login.vue